<template>
  <div>
    <v-layout wrap class="mt-4">
      <v-flex xs9 style="display: flex; align-items: center">
        <div>
          <multiselect
            v-model="filters.lang"
            disabled
            :options="langOptions"
            label="label"
            select-label
            selected-label
            :allow-empty="false"
            :searchable="false"
            deselect-label
            track-by="label"
            style="width: 100px"
            @input="handleFetchWhatsappTemplate"
          ></multiselect>
        </div>
        <div class="form-control px-4" style="width: 100%">
          <input
            v-model="filters.search"
            type="text"
            :placeholder="$t('Search')"
            class="mb-0"
            style="max-width: 350px"
            @input="handleSearch"
          />
        </div>
      </v-flex>
      <v-flex xs3 class="text-xs-right">
        <v-btn
          v-if="!isLiveChat"
          outline
          color="primary"
          @click="
            formType = 'create'
            templateManageFormDialogOpen = true
          "
        >
          <em class="fa fa-plus mr-1"></em>
          {{ $t('whatsapp_add_template') }}
        </v-btn>
      </v-flex>
    </v-layout>

    <div class="mt-5">
      <template v-if="dataList.length > 0">
        <template v-for="(item, index) in dataList">
          <template-item-card
            :key="`whatsapp-template-${index + 1}`"
            :is-live-chat="isLiveChat"
            :item="item"
            @onRefetchData="handleRefetchData"
            @onEdit="handleEditTemplate"
            @onEditAndSend="handleEditAndSendTemplate"
            @sendToLivechat="sendToLivechat"
          />
        </template>
        <v-layout class="mt-2" justify-center>
          <v-pagination
            v-model="pageNumber"
            :total-visible="6"
            :length="pageLength"
            @input="handleChangePage"
          ></v-pagination>
        </v-layout>
      </template>
      <template v-else>
        <v-card
          elevation="0"
          style="border: 1px solid #ccc; border-radius: 8px"
          class="pa-3 text-xs-center"
        >
          {{ $t('No data') }}
        </v-card>
      </template>
    </div>

    <v-dialog v-model="templateManageFormDialogOpen" persistent width="800px">
      <TemplateManageForm
        v-if="templateManageFormDialogOpen"
        :is-live-chat="isLiveChat"
        :item="selectedItem"
        :form-type="formType"
        :lang="filters.lang.value"
        @onRefetchData="handleRefetchData"
        @close="
          selectedItem = null
          templateManageFormDialogOpen = false
        "
        @sendToLivechat="sendToLivechat"
      />
    </v-dialog>
  </div>
</template>

<script>
import whatsappApi from '@/api/whatsapp.js'
import { mapGetters } from 'vuex'
import TemplateItemCard from './TemplateItemCard.vue'
import TemplateManageForm from './TemplateManageForm.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    TemplateItemCard,
    TemplateManageForm,
    Multiselect
  },
  props: {
    isLiveChat: {
      type: Boolean,
      default: false
    },
    livechatPageId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      total: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      pageTemp: 1,
      pageNumber: 1,
      dataList: [],
      updateSearchTimeout: null,
      loadingSearch: false,
      filters: {
        lang: { label: 'EN', value: 'en' },
        search: ''
      },
      langOptions: [
        { label: 'EN', value: 'en' },
        { label: 'TH', value: 'th' }
      ],
      templateManageFormDialogOpen: false,
      formType: 'create',
      selectedItem: null
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageLength() {
      if (this.total) {
        const total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  // watch: {
  //   filters: {
  //     deep: true,
  //     handler() {
  //       this.handleSearch()
  //     }
  //   }
  // },
  mounted() {
    this.handleFetchWhatsappTemplate()
  },
  methods: {
    async handleFetchWhatsappTemplate() {
      const vm = this
      try {
        vm.$store.dispatch('loading')

        const data = {
          page_id: vm.selectedBot.pageid,
          limit: vm.limit,
          offset: vm.offset
        }

        if (vm.filters && vm.filters.lang) {
          Object.assign(data, { lang: vm.filters.lang.value })
        }

        if (vm.filters && vm.filters.search) {
          Object.assign(data, { name: vm.filters.search })
        }

        if (vm.isLiveChat) {
          Object.assign(data, { active: true })
        }

        const response = await vm.getWhatsappTemplate(data)
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.status === 200) {
          vm.dataList = response.data.data
          vm.total = vm.dataList[0].total
        }
      } catch (error) {
        console.error(error)
      } finally {
        vm.$store.commit('CLEAR_LOADING')
      }
    },
    async handleRefetchData() {
      this.offset = 0
      this.pageNumber = 1
      await this.handleFetchWhatsappTemplate()
    },
    async getWhatsappTemplate(payload) {
      try {
        const response = await whatsappApi.getWhatsappTemplate({
          config: {
            params: payload
          }
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleChangePage(val) {
      const vm = this
      if (vm.pageTemp !== val) {
        vm.pageTemp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleFetchWhatsappTemplate()
      }
    },
    handleSearch() {
      const vm = this

      if (vm.updateSearchTimeout) {
        clearTimeout(vm.updateSearchTimeout)
      }
      if (vm.loadingSearch) {
        return false
      }

      vm.updateSearchTimeout = setTimeout(async () => {
        vm.loadingSearch = true
        try {
          await vm.handleRefetchData()
        } catch (error) {
          console.error(error)
        }
        vm.loadingSearch = false
        vm.updateSearchTimeout = null
      }, 1500)
    },
    handleEditTemplate(item) {
      this.selectedItem = item
      this.formType = 'edit'
      this.templateManageFormDialogOpen = true
    },
    handleEditAndSendTemplate(item) {
      this.selectedItem = item
      this.formType = 'edit_send'
      this.templateManageFormDialogOpen = true
    },
    sendToLivechat(template) {
      this.$emit('sendToLivechat', template)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/whatsapp/TemplateManagement/TemplateList.vue